<app-common-table
  tabindex="0"
  aria-label="Student behavior history table"
  *ngIf="dataArr.length"
  [getColumnValue]="getColumnValue"
  [columns]="displayedColumns"
  [tableFilters]="tableFilters"
  [templates]="templates"
  [dataArr]="dataArr"
  (tableFiltersUpdated)="updateTableFilters($event)">
</app-common-table>

<ng-template #actionButtons let-eventCategory="eventCategory">
  <button
    mat-flat-button
    type="submit"
    (click)="edit(eventCategory.id)"
    class="action-button edit-button icon-button"
    options-id="EDIT_EVENT_CATEGORY"
    [option]="eventCategory.id">
    <fa-icon [icon]="['fas', 'edit']"></fa-icon>
  </button>
  <button
    type="submit"
    mat-flat-button
    (click)="delete(eventCategory.id)"
    class="action-button delete-button icon-button"
    options-id="EDIT_EVENT_CATEGORY"
    [option]="eventCategory.id">
    <fa-icon [icon]="['fas', 'trash-alt']"></fa-icon>
  </button>
</ng-template>

